import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { PageMixin } from '../_internal/PageMixin';
import Form from "./FromTs";


@Component
export default class PaymentCreate extends PageMixin {

    public type: string = "deposits";
    public title: string = 'Recent Deposit';
    public editName: string = 'Transaction.deposit.edit';

    render(h: CreateElement) {

        return this.renderCollection(h, h(Form, {
            props: {
                type: this.type,
                id: this.id,
            },
            on: {
                push: this.push
            }
        }))

    }
}